import { render, staticRenderFns } from "./IcmsDetalhes.vue?vue&type=template&id=10926980"
import script from "./IcmsDetalhes.vue?vue&type=script&lang=js"
export * from "./IcmsDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports